<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-stepper v-model="currentStep">
    <v-form
      v-model="isFormValid"
      lazy-validation
      ref="form"
      @submit.prevent="addNewAthlete"
    >
      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step="1">
          Personal Info
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="currentStep > 2" step="2">
          Wavier
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="currentStep > 3" step="3">
          Payment
        </v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-container grid-list-md>
            <athlete_form
              v-bind:hidePhoto="true"
              v-bind:hideLang="true"
              v-bind:hideCountry="true"
              v-bind:hideStatus="true"
              v-bind:StatusInactive="true"
              v-bind:showPhone="true"
              v-bind:info="true"
              v-bind:hideTeam="true"
              v-bind:teamName="TRYOUT"
              v-bind:teamId="1"
              v-bind:dark="false"
              @childData="handleChildData"
            ></athlete_form>
            <guardian_form
              v-bind:dark="false"
              v-model="guardian1"
              v-bind:title="'Guardian 1'"
              @input="handleGuardian1"
            >
            </guardian_form>
            <guardian_form
              v-bind:dark="false"
              v-model="guardian2"
              v-bind:title="'Guardian 2'"
              @input="handleGuardian2"
            >
            </guardian_form>
            <medical_form
              v-bind:dark="false"
              v-model="medical"
              v-bind:title="'Medical'"
              @input="handleMedical"
            >
            </medical_form>
            <emergency_contact_form
              v-bind:dark="false"
              v-model="emergencyContact1"
              v-bind:title="'Emergency Contact 1'"
              @input="handleEmergencyContact1"
            ></emergency_contact_form>
            <emergency_contact_form
              v-bind:dark="false"
              v-model="emergencyContact2"
              v-bind:title="'Emergency Contact 2'"
              @input="handleEmergencyContact2"
            ></emergency_contact_form>
          </v-container>
          <!-- <v-btn
            outlined
            color="primary"
            type="submit"
            style="width: 100%;"
            :loading="loading"
            data-cy="signUpButton"
          >
            Register
          </v-btn> -->
          <v-btn color="primary" @click="nextStep">Continue</v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="mb-12">
            <div class="termsStyle">
              <!-- <div v-for="clubForm in clubForms" :key="clubForm.id"> -->
              <div
                v-for="(clubForm, index) in clubForms"
                :key="clubForm.id"
                v-if="index === 0"
              >
                <p>
                  <strong>Terms and Conditions</strong>
                  {{ clubForm.termsAndConditions }}
                </p>
                <p>
                  <strong>Medical Consent Authorization</strong>
                  {{ clubForm.medicalConsentAuthorization }}
                </p>
                <p>
                  <strong>Parent Volunteer Time</strong>
                  {{ clubForm.parentVolunteerTime }}
                </p>
                <p>
                  <strong>Photograph Permission</strong>
                  {{ clubForm.photographPermission }}
                </p>
                <p>
                  <strong>Senior Members Commitment</strong>
                  {{ clubForm.seniorMembersCommitment }}
                </p>
                <p>
                  <strong>Swimmer Rule Conduct</strong>
                  {{ clubForm.swimmerRuleConduct }}
                </p>
                <p>
                  <strong>Update Source</strong> {{ clubForm.updateSource }}
                </p>
                <p>
                  <strong>Waiver Of Liability</strong>
                  {{ clubForm.waiverOfLiability }}
                </p>
              </div>
            </div>
            <v-checkbox
              id="checkboxOG"
              style="align-self: flex-start"
              required
              :rules="currentStep === 2 ? agreeRules : []"
              v-model="privacyPolicy"
              label="Agree to terms and conditions"
            ></v-checkbox>
          </v-card>
          <v-btn color="primary" @click="nextStep">Continue</v-btn>
          <v-btn text @click="prevStep">Back</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <h1>Paypal/Stripe</h1>
          <v-card class="mb-12"> </v-card>
          <!-- type="submit" -->
          <v-btn type="submit" color="primary"
            >Submit and Proceed to payment</v-btn
          >
          <v-btn text @click="prevStep">Back</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-form>
  </v-stepper>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationRules } from "../../constants/global";
import athlete_form from "./athlete_form.vue";
import guardian_form from "./guardian_form.vue";
import medical_form from "./medical_form.vue";
import emergency_contact_form from "./emergency_contact_form.vue";

export default {
  data() {
    return {
      currentStep: 1,
      showPass: false,
      showConfirmPass: false,
      menu: false,
      userEmail: "",
      birthDate: "",
      privacyPolicy: false,
      privacyTermsOfService: false,
      gender: "",
      role: "",
      isFormValid: true,
      password: "",
      teamId: "",
      passwordConfirmation: "",
      userName: "",
      userNameRules: validationRules.name,
      userEmailRules: validationRules.email,
      requiredRule: validationRules.required,
      tab: null,
      agreeRules: [v => !!v || "field is required"],
      items: ["Tryout Registration", "Club Program Registration"],
      text: "Lorem ipsum dolor sit amet.",
      passwordRules: [
        password => !!password || "Password is required",
        password =>
          password.length >= 4 || "Password must be at least 4 characters",
        confirmation => confirmation === this.password || "Passwords must match"
      ],
      guardian1: {
        guardianName: "",
        guardianLastname: "",
        guardianEmail: "",
        guardianPhone: "",
        guardianOccupation: "",
        guardianRelationship: ""
      },
      guardian2: {
        guardianName: "",
        guardianLastname: "",
        guardianEmail: "",
        guardianPhone: "",
        guardianOccupation: "",
        guardianRelationship: ""
      },
      medical: {
        PhysicianOHIP: "",
        physicianFirstName: "",
        physicianLastName: "",
        physicianPhone: "",
        physicianMedicalProblems: "",
        physicianTreatmentTaken: ""
      },
      emergencyContact1: {
        emergencyFirstName: "",
        emergencyLastname: "",
        emergencyPhone: "",
        emergencyAthleteRelationship: ""
      },
      emergencyContact2: {
        emergencyFirstName: "",
        emergencyLastname: "",
        emergencyPhone: "",
        emergencyAthleteRelationship: ""
      }
    };
  },
  computed: {
    ...mapGetters(["loading", "error", "user", "allClubFormData"]),
    clubForms() {
      return this.allClubFormData;
    }
  },
  methods: {
    ...mapActions(["addUpdateAthlete"]),
    handleChildData(data) {
      this.formData = data;
    },
    handleGuardian1(data) {
      this.guardian1 = data;
    },
    handleGuardian2(data) {
      this.guardian2 = data;
    },
    handleMedical(data) {
      this.medical = data;
    },
    handleEmergencyContact1(data) {
      this.EmergencyContact1 = data;
    },
    handleEmergencyContact2(data) {
      this.EmergencyContact2 = data;
    },
    addNewAthlete() {
      if (this.$refs.form.validate()) {
        console.log("inside club reg component ");
        this.loadingTable = true;
        const birthDate = new Date(this.formData.birthDate);
        const formattedBirthDate = birthDate.toISOString().split("T")[0];
        this.addUpdateAthlete({
          athleteData: {
            firstName: this.formData.firstName,
            lastName: this.formData.lastName,
            email: this.formData.email,
            status: this.formData.status,
            birthDate: formattedBirthDate,
            photo: this.formData.photo,
            teamId: this.formData.teamId,
            clubId: this.$route.params.clubId,
            gender: this.formData.gender,
            additionalInfo: JSON.stringify({
              guardian1: {
                guardianName: this.guardian1.guardianName,
                guardianLastname: this.guardian1.guardianLastname,
                guardianEmail: this.guardian1.guardianEmail,
                guardianPhone: this.guardian1.guardianPhone,
                guardianOccupation: this.guardian1.guardianOccupation,
                guardianRelationship: this.guardian1.guardianRelationship
              },
              guardian2: {
                guardianName: this.guardian2.guardianName,
                guardianLastname: this.guardian2.guardianLastname,
                guardianEmail: this.guardian2.guardianEmail,
                guardianPhone: this.guardian2.guardianPhone,
                guardianOccupation: this.guardian2.guardianOccupation,
                guardianRelationship: this.guardian2.guardianRelationship
              },
              medical: {
                PhysicianOHIP: this.medical.PhysicianOHIP,
                physicianFirstName: this.medical.physicianFirstName,
                physicianLastName: this.medical.physicianLastName,
                physicianPhone: this.medical.physicianPhone,
                physicianMedicalProblems: this.medical.physicianMedicalProblems,
                physicianTreatmentTaken: this.medical.physicianTreatmentTaken
              },
              emergencyContact1: {
                emergencyFirstName: this.EmergencyContact1.emergencyFirstName,
                emergencyLastname: this.EmergencyContact1.emergencyLastname,
                emergencyPhone: this.EmergencyContact1.emergencyPhone,
                emergencyAthleteRelationship: this.EmergencyContact1
                  .emergencyAthleteRelationship
              },
              emergencyContact2: {
                emergencyFirstName: this.EmergencyContact2.emergencyFirstName,
                emergencyLastname: this.EmergencyContact2.emergencyLastname,
                emergencyPhone: this.EmergencyContact2.emergencyPhone,
                emergencyAthleteRelationship: this.EmergencyContact2
                  .emergencyAthleteRelationship
              }
            }),
            language: this.formData.language,
            phone: this.formData.phone,
            country: this.formData.country,
            createDate: this.moment.format("YYYY-MM-DD"),
            startMembership: this.moment.format("YYYY-MM-DD"),
            updateSource: "Test source"
          }
        })
          .then(() => {
            this.loadingTable = false;
            this.$toast.success(
              `Athlete ${this.formData.firstName} has been added`
            );
            this.$refs.form.reset();
            // this.$router.push("/landing");
            // alert(this.formData.firstName, "has been registered");
          })
          .catch(error => {
            this.loadingTable = false;
            console.error(error);
            this.close();
          });
      }
    },
    nextStep() {
      if (this.$refs.form.validate()) {
        this.currentStep++;
      }
    },
    prevStep() {
      this.currentStep--;
    },
    resetForm() {
      this.currentStep = 1;
    },
    submitForm() {
      console.log("Form submitted successfully!");
    }
  },
  components: {
    athlete_form,
    guardian_form,
    medical_form,
    emergency_contact_form
  }
};
</script>
